import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { PageEvent, MatTableDataSource, Sort, MatSelect, MatTable, MatSort, MatExpansionPanel, MatSnackBar } from '@angular/material';
import { Subscription, ReplaySubject } from 'rxjs';
import { CotizacionService } from '../../../providers/cotizacion.service';
import { Cotizacion, TipoCotizacion, EstadoCotizacion } from '../../../interfaces/cotizacion';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { Item } from '../../../interfaces/item';
import { TipoGarantia } from '../../../interfaces/tipo-garantia';
import * as moment from 'moment';
import { EntidadService } from '../../../providers/entidad.service';
import { FormControl } from '@angular/forms';
import { TipoMoneda } from '../../../interfaces/tipo-moneda';
import { TipoPago } from '../../../interfaces/tipo-pago';
import { TipoValidez } from '../../../interfaces/tipo-validez';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { UsuarioService } from '../../../providers/usuario.service';
import { Telefono } from '../../../components/telefono/telefono.component';
import { TipoEntrega } from '../../../interfaces/tipo-entrega';
import { AuthenticationService } from '../../../providers/auth.service';
import { Competidor } from '../../../interfaces/competidor';
import { CompetidorService } from '../../../providers/competidor.service';
import { VolverService } from '../../../providers/volver.service';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { CaracteristicaService } from '../../../providers/caracteristica.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ver-cotizaciones',
  templateUrl: './ver-cotizaciones.component.html',
  styleUrls: ['./ver-cotizaciones.component.scss']
})
export class VerCotizacionesComponent implements OnInit {
  title = "Cotizaciones";
  hoy = moment().format('YYYY-MM-DD');
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaCotizacionesColumnas = [
    'numero',
    'prospecto',
    'fechaAlta',
    //'obra',
    'tipoCotizacion',
    'estado',
    'fechaVencimiento',
    'created_by',
    //'asignada',
    'total'
  ];
  minimalColumns = [
    'numero',
    'fechaAlta',
    'estado',
    'tipoCotizacion',
    'created_by',
    'asignada',
    'total',
    'fechaVencimiento'
  ]
  cotizacionesDataSource = new MatTableDataSource();
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  getCotizacionesSuscripcion: Subscription;
  cotizacionesCount: number = 0;
  cotizacionEstados: EstadoCotizacion[] = [];
  cargandoEstados = false;
  tiposCotizacion: TipoCotizacion[] = [];
  cargandoTiposCotizacion: boolean = false;
  competidores: Competidor[] = [];
  cargandoCompetidores: boolean = false;
  entidades: Entidad[] = [];
  cargandoEntidades: boolean = false;
  usuarios: Usuario[] = [];
  cargandoUsuarios: boolean = false;
  // si tiene algún elemento, es que se está cargando algo para los filtros
  cargandoFiltros = [];
  hoveredIndex: number;
  // true si hay alguna variable de estado de pagina aplicada (filtro, orden, paginado...etc)
  tieneFiltrosOrdenPaginado = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo && !this.filtrosExternos) {
          v.open();
        }
      }, 0);
    }
  };
  @ViewChild('tablaCotizaciones') tablaCotizaciones: MatTable<any>;
  // para el select con buscador 
  public entidadesFiltroCtrl: FormControl = new FormControl();
  public entidadesFiltradas: ReplaySubject<Entidad[]> = new ReplaySubject<Entidad[]>(1);
  @ViewChild('filtroEntidad') set filtroEntidad(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdEntidad == b.IdEntidad; };
  };
  @ViewChild('filtroEstadoCotizacion') set filtroEstadoCotizacion(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdEstado == b.IdEstado; };
  };
  @ViewChild('filtroTipoCotizacion') set filtroTipoCotizacion(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdTipo == b.IdTipo; };
  };
  @ViewChild('filtroEntidadResponsable') set filtroEntidadResponsable(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdUsuario == b.IdUsuario; };
  };
  @ViewChild('filtroCreadaPor') set filtroCreadaPor(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdUsuario == b.IdUsuario; };
  };
  @ViewChild('filtroCompetidor') set filtroCompetidor(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.id == b.id; };
  };
  cmpCaracteristicaValor = (a, b) => { return a && b && a.IdCaracteristicaValor == b.IdCaracteristicaValor; };
  @ViewChild('filtroCotizacionResponsable') set filtroCotizacionResponsable(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdUsuario == b.IdUsuario; };
  };
  @Input() minimal: boolean = false; // Seteo para vista minima en componente
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  @Output() onChange = new EventEmitter(); // emite el estado del formulario
  filtros: any = {
    generico: '',
    numero: '',
    estadoCotizacion: '',
    tipoCotizacion: '',
    entidad: '',
    entidadResponsable: '',
    created_by: '',
    fechaCreadaDesde: '',
    fechaCreadaHasta: '',
    fechaVencimientoDesde: '',
    fechaVencimientoHasta: '',
    ItemDetalle: '',
    competidor: '',
    responsable: ''
  };
  descargandolistado: boolean = false;
  cargandoCaracteristicas: boolean = false;
  caracteristicas = [];
  IdPropuesta: number;
  constructor(
    private cotizacionService: CotizacionService,
    private entidadService: EntidadService,
    private usuarioService: UsuarioService,
    private authenticationService: AuthenticationService,
    private competidorService: CompetidorService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private datePipe: FormatDatePipe,
    private _route: ActivatedRoute,
    private caracteristicaSv: CaracteristicaService
  ) { }

  ngOnInit() {
    // cuando cambia el valor del buscador de entidades, filtramos las entidades
    this.entidadesFiltroCtrl.valueChanges
      .subscribe(() => {
        this.filtrarEntidades();
      });
    // activar filtro
    this.entidadesFiltradas.subscribe();
    //Muestro campos si minimal viene true
    if (this.minimal) {
      this.tablaCotizacionesColumnas = this.tablaCotizacionesColumnas.filter(
        f => this.minimalColumns.includes(f)
      );
    }
    // cargar valores de los filtros
    this.traerEstados();
    this.traerTiposCotizacion();
    this.traerEntidades();
    this.traerUsuarios();
    this.traerCompetidores();
    this.traerCaracteristicas();

    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
    this._route.params.subscribe(params => {
      if (params['id']){
        this.IdPropuesta = params['id'];
        this.filtros['IdPropuesta'] = this.IdPropuesta;
        this.actualizarTabla();
      }
    });
  }

  fechaCreadaDesdeFilter = (d: moment.Moment): boolean => {
    // lógica de la "fecha desde":
    // (hoy menos un año) <= (fecha desde) <= (fecha hasta || hoy más un año)   
    return d.isSameOrAfter(moment().subtract(1, 'year')) && d.isSameOrBefore(this.filtros.fechaCreadaHasta || moment().add(1, 'year'));
  }

  fechaCreadaHastaFilter = (d: moment.Moment): boolean => {
    // lógica de la "fecha hasta":
    // (fecha desde || hoy menos un año) <= (fecha hasta) <= (hoy más un año)  
    return d.isSameOrAfter(this.filtros.fechaCreadaDesde || moment().subtract(1, 'year')) && d.isSameOrBefore(moment().add(1, 'year'));
  }

  fechaVencimientoDesdeFilter = (d: moment.Moment): boolean => {
    // lógica de la "fecha desde":
    // (hoy menos un año) <= (fecha desde) <= (fecha hasta || hoy más un año)   
    return d.isSameOrAfter(moment().subtract(1, 'year')) && d.isSameOrBefore(this.filtros.fechaVencimientoHasta || moment().add(1, 'year'));
  }

  fechaVencimientoHastaFilter = (d: moment.Moment): boolean => {
    // lógica de la "fecha hasta":
    // (fecha desde || hoy menos un año) <= (fecha hasta) <= (hoy más un año)  
    return d.isSameOrAfter(this.filtros.fechaVencimientoDesde || moment().subtract(1, 'year')) && d.isSameOrBefore(moment().add(1, 'year'));
  }

  traerUsuarios(): void {
    this.cargandoUsuarios = true;
    this.cargandoFiltros.push(true);
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }

        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  /**
   * Función que sabe como filtrar las entidades
   */
  private filtrarEntidades() {
    if (!this.entidades) {
      return;
    }
    // get the search keyword
    let search = this.entidadesFiltroCtrl.value;
    if (!search) {
      this.entidadesFiltradas.next(this.entidades.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.entidadesFiltradas.next(
      this.entidades.filter(entidad => {
        return (entidad.razonSocial.toLowerCase().indexOf(search) > -1);
      })
    );
  }

  /**
   * Activa el modo seguimiento
   */
  activarModoSeguimiento() {
    this.page.pageIndex = 0;
    // cotizaciones creadas por mi
    this.filtros.created_by = this.usuarios.find((usuario: Usuario) => {
      return usuario.usuario == this.authenticationService.usuario;
    });
    // cotizaciones en estado pendiente
    this.filtros.estadoCotizacion = this.cotizacionEstados.find((estado: EstadoCotizacion) => {
      return estado.descripcion == "PENDIENTE";
    });
    // ordendas por fecha vencimiento descendente
    this.setActiveSortProgrammatically("fechaVencimiento", "desc");
    this.actualizarTabla();
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_cotizaciones_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_cotizaciones_filtros', null);
    // paginado
    localStorage.setItem('ver_cotizaciones_paginado', null);
    // sort
    localStorage.setItem('ver_cotizaciones_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_cotizaciones_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_cotizaciones_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_cotizaciones_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_cotizaciones_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_cotizaciones_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_cotizaciones_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_cotizaciones_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaAlta', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaAlta' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  actualizarTabla(): void {

    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      // mostrar cargando si tarda mas de algun tiempo
      this.cargandoTimeout = setTimeout(() => {
        this.cargando = true;
      }, 750);

      if (this.getCotizacionesSuscripcion && !this.getCotizacionesSuscripcion.closed) {
        this.getCotizacionesSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getCotizacionesSuscripcion = this.cotizacionService
        .getCotizaciones(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          // filtros del componente mas los filtros según donde se muestra el componente
          Object.assign(this.filtrosExternos, this.filtros)
        )
        .subscribe(
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.cotizacionesCount = respuesta.data.total;
              }
              // array de datos obtenidos
              var cotizaciones: Cotizacion[] = <Cotizacion[]>[];
              if (respuesta.data.cotizaciones) {
                respuesta.data.cotizaciones.forEach(cotizacion => {
                  cotizaciones.push(new Cotizacion(
                    cotizacion.IdCotizacion,
                    cotizacion.fechaAlta,
                    <Entidad>{
                      IdEntidad: cotizacion.entidad.id,
                      razonSocial: cotizacion.entidad.razonSocial,
                      tipoEntidad: <TipoEntidad>{
                        IdTipo: cotizacion.entidad.tipo.IdTipo,
                        descripcion: cotizacion.entidad.tipo.TipoDescripcion
                      }
                    },
                    <TipoCotizacion>{
                      IdTipo: cotizacion.tipo.id,
                      descripcion: cotizacion.tipo.descripcion
                    },
                    cotizacion.detalle,
                    <Item[]>[],
                    new TipoEntrega(
                      cotizacion.tipoEntrega.id,
                      cotizacion.tipoEntrega.descripcion
                    ),
                    <EstadoCotizacion>{
                      IdEstado: cotizacion.estado.id,
                      descripcion: cotizacion.estado.descripcion
                    },
                    cotizacion.total,
                    <TipoGarantia>{
                      id: cotizacion.garantia.id,
                      descripcion: cotizacion.garantia.descripcion
                    },
                    Object.assign([], cotizacion.condiciones),
                    cotizacion.obra,
                    cotizacion.fechaVencimiento,
                    cotizacion.horaVencimiento ? cotizacion.horaVencimiento : null,
                    cotizacion.estadoMotivo,
                    cotizacion.destinoEntrega,
                    new TipoMoneda(
                      cotizacion.moneda.id,
                      cotizacion.moneda.descripcion,
                      cotizacion.moneda.subfijo
                    ),
                    new TipoPago(
                      cotizacion.pago.id,
                      cotizacion.pago.descripcion
                    ),
                    new TipoValidez(
                      cotizacion.validez.id,
                      cotizacion.validez.descripcion
                    ),
                    Object.assign([], cotizacion.tipoImpuesto),
                    cotizacion.fechaApertura,
                    !!+cotizacion.editable,
                    cotizacion.created_by,
                    cotizacion.numero,
                    cotizacion.fechaHoraModificacion,
                    new Competidor(
                      cotizacion.competidor.id,
                      cotizacion.competidor.descripcion
                    ),
                    cotizacion.vecesModificada,
                    new Usuario(
                      cotizacion.responsable.IdUsuario,
                      cotizacion.responsable.usuario,
                      null,
                      null,
                      null,
                      cotizacion.responsable.nombre,
                      cotizacion.responsable.apellido
                    ),
                    !!+cotizacion.alMenosUnArchivo
                  ));
                });
              }

              this.cotizacionesDataSource.data = cotizaciones;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando            
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  traerEstados(): void {
    this.cotizacionEstados = [];
    this.cargandoEstados = true;
    this.cargandoFiltros.push(true);
    this.cotizacionService.getEstadosCotizacion(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        sortOrder: null
      },
      {
        generico: '',
        verTodos: true // solo sirve para los gets, ignora la validación por rol
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1) {
          respuesta.data.estados.forEach((estado) => {
            this.cotizacionEstados.push(<EstadoCotizacion>{
              IdEstado: estado.id,
              descripcion: estado.descripcion
            });
          });
        }

        this.cargandoEstados = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoEstados = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  traerTiposCotizacion(): void {
    this.tiposCotizacion = [];
    this.cargandoTiposCotizacion = true;
    this.cargandoFiltros.push(true);
    this.cotizacionService.getTiposCotizacion().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposCotizacion) {
          respuesta.data.tiposCotizacion.forEach(tipoCotizacion => {
            this.tiposCotizacion.push(<TipoCotizacion>{
              IdTipo: tipoCotizacion.IdTipoCoti,
              descripcion: tipoCotizacion.TipoCotiDesc
            });
          });
        }
      },
      () => {
        this.cargandoTiposCotizacion = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoTiposCotizacion = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  traerCompetidores(): void {
    this.competidores = [];
    this.cargandoCompetidores = true;
    this.cargandoFiltros.push(true);
    this.competidorService.getCompetidores().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.competidores) {
          respuesta.data.competidores.forEach(competidor => {
            this.competidores.push(new Competidor(
              competidor.id,
              competidor.descripcion
            ));
          });
        }
      },
      () => {
        this.cargandoCompetidores = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoCompetidores = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  traerCaracteristicas() {
    this.cargandoCaracteristicas = true;
    this.caracteristicaSv.getCaracteristicas().subscribe(
      respuesta => {
        this.caracteristicas = [];
        if (respuesta && respuesta.estado == 1 && respuesta.data) {
          this.caracteristicas = respuesta.data;
        }
      },
      () => {
        this.cargandoCaracteristicas = false;
      },
      () => {
        this.cargandoCaracteristicas = false;
      }
    );
  }

  traerEntidades(): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.cargandoFiltros.push(true);
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 200
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((entidad: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: entidad.id,
              razonSocial: entidad.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: entidad.tipo.IdTipo,
                descripcion: entidad.tipo.TipoDescripcion
              }
            });
          });

          // actualizar filtros del listado de entidades
          this.filtrarEntidades();
        }

        this.cargandoEntidades = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoEntidades = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  onDatoCambiado(): void {
    this.onChange.emit();
  }

  descargarListado() {
    this.descargandolistado = true;
    this.cotizacionService.getCotizaciones(
      {
        page: 0,
        pageSize: this.cotizacionesCount
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.cotizaciones) {
          const titulos = [
            "ID cotización",
            "Número",
            "Fecha de alta",
            "Fecha de apertura",
            "Creada por",
            "Asignada",
            "Prospecto/Cliente",
            "Razón social",
            "Tipo de cotización",
            "Fecha de vencimiento",
            "Hora de vencimiento",
            "Estado",
            "Estado descripción",
            "Tipo de garantía",
            "Tipo de pago",
            "Tipo de moneda",
            "Tipo de validez",
            "Obra",
            "Tipo de entrega",
            "Destino de entrega",
            "Total",
            "Fecha de modificación",
            "Competidor",
            "Veces modificada",
            "Impuestos",
            "Notas"
            // TODO: no se agregaron las condiciones comerciales porque no lo usan
          ].join(';') + "\r\n";

          let cotizacionesParaExportar = [];
          const datos = respuesta.data.cotizaciones.map((a: any) => {
            cotizacionesParaExportar.push(a.IdCotizacion);

            return [
              a.IdCotizacion,
              a.numero,
              this.datePipe.transform(a.fechaAlta, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              this.datePipe.transform(a.fechaApertura, "YYYY-MM-DD", "DD/MM/YYYY"),
              a.created_by,
              a.responsable && a.responsable.IdUsuario ? ((a.responsable.nombre || a.responsable.apellido) ? a.responsable.nombre + ' ' + a.responsable.apellido : a.responsable.usuario) : '',
              a.entidad.tipo.TipoDescripcion,
              a.entidad.razonSocial,
              a.tipo.descripcion,
              this.datePipe.transform(a.fechaVencimiento, "YYYY-MM-DD", "DD/MM/YYYY"),
              this.datePipe.transform(a.horaVencimiento, "HH:mm:ss", "HH:mm"),
              a.estado.descripcion,
              a.estadoMotivo,
              a.garantia.descripcion,
              a.pago.descripcion,
              a.moneda && a.moneda.descripcion ? ((a.moneda.subfijo ? "(" + a.moneda.subfijo + ") " : '') + a.moneda.descripcion) : '',
              a.validez.descripcion,
              a.obra,
              a.tipoEntrega.descripcion,
              a.destinoEntrega,
              a.total,
              this.datePipe.transform(a.fechaHoraModificacion, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              a.competidor.descripcion,
              a.vecesModificada,
              a.tipoImpuesto ? a.tipoImpuesto.map((impuesto) => impuesto.descripcion).join(', ') : '',
              a.detalle.replace(/(\r\n|\n|\r)/gm, ' ') // remover todos los saltos de linea
            ].join(';');
          }).join("\r\n");

          const fecha = moment().format("YYYYMMDD_HHmmss");
          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = this.title + "_" + fecha + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          this.descargarListadoItems(cotizacionesParaExportar, fecha);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  descargarListadoItems(cotizaciones, fecha) {
    this.descargandolistado = true;
    this.cotizacionService.getCotizacionItems(
      {
        page: 0,
        pageSize: null
      },
      {
        sort: 'cotizacion',
        order: this.sort.direction
      },
      {
        cotizacionesIDs: cotizaciones
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.items) {
          const titulos = [
            "ID cotización",
            "ID ítem",
            "Producto",
            "Cantidad",
            "Precio unitario",
            "Plazo",
            "Etiqueta",
            "Detalle",
            "Accesorios"
          ].join(';') + "\r\n";

          let accesoriosParaExportar = [];
          const datos = respuesta.data.items.map((a: any) => {
            if (a.accesorios.length > 0) {
              a.accesorios.forEach(accesorio => {
                accesoriosParaExportar.push(accesorio);
              });
            }

            return [
              a.cotizacion.IdCotizacion,
              a.IdItem,
              a.producto.descripcion,
              a.cantidad,
              !!+a.productoPrecioIncluido ? 'Incluido' : a.precioUnitario,
              a.plazo.descripcion != null ? a.plazo.descripcion : '',
              a.label != null ? a.label.replace(/(\r\n|\n|\r)/gm, ' ') : '',
              a.customDescripcion != null ? a.customDescripcion.replace(/(\r\n|\n|\r)/gm, ' ') : '',
              a.accesorios ? a.accesorios.map((accesorio) => accesorio.descripcion).join(', ') : ''
            ].join(';');
          }).join("\r\n");

          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = "Items" + "_" + fecha + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          this.descargarListadoAccesorios(accesoriosParaExportar, fecha);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  /**
   * en este listado no se hace request al sv
   * porque son los que vienen en el request anterior
   */
  descargarListadoAccesorios(accesorios, fecha) {
    if (accesorios.length > 0) {
      this.descargandolistado = true;
      setTimeout(() => {
        const titulos = [
          "ID ítem",
          "ID Accesorio",
          "Cantidad",
          "Importe",
          "Descripción"
        ].join(';') + "\r\n";

        const datos = accesorios.map((a: any) => {
          return [
            a.IdItem,
            a.id,
            a.cantidad,
            (!!+a.precioIncluido ? a.precioDescripcion : a.importeAsignado) || 0,
            a.descripcion
          ].join(';');
        }).join("\r\n");

        const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
        let csvContent = titulos + datos;
        let downloadLink = document.createElement("a");
        downloadLink.href = csvConfig + encodeURI(csvContent);
        downloadLink.download = "Accesorios" + "_" + fecha + ".csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        this.descargandolistado = false;
      }, 0);
    }
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  buscandoArchivosCotizacion = false;
  descargarArchivosCotizacion(IdCotizacion) {
    this.buscandoArchivosCotizacion = true;
    this.cotizacionService
      .getArchivosCotizacion(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaAlta',
          order: 'asc'
        },
        {
          IdCotizacion: IdCotizacion
        }
      )
      .subscribe(
        respuesta => {
          if (respuesta) {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.archivos) {
                respuesta.data.archivos.forEach((archivo) => {
                  let downloadLink = document.createElement("a");
                  downloadLink.href = encodeURI(archivo.link);
                  downloadLink.download = archivo.nombreWeb;
                  downloadLink.target = "_blank";
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                });
              }
            } else if (respuesta.estado != 1) {
              this.snackBar.open('Lo sentimos, no se pudo descargar los archivos', 'OK', { duration: 4750 });
            }
          }
          this.buscandoArchivosCotizacion = false;
        },
        () => {
          this.snackBar.open('Lo sentimos, no se pudo descargar los archivos', 'OK', { duration: 4750 });
          this.buscandoArchivosCotizacion = false;
        }
      );
  }

  ngOnDestroy() {
    if (this.getCotizacionesSuscripcion && !this.getCotizacionesSuscripcion.closed) {
      this.getCotizacionesSuscripcion.unsubscribe();
    }
  }
}
